import React, { useRef } from 'react';
import CardContainer from 'src/components/common/CardContainer.redesign';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
import { TweenLite } from 'gsap';
import LoadingSpinner from 'src/components/common/LoadingSpinner';

interface IRunsheetTractListProps {
    tracts?: Array<LeaseGenerationTractDetail>;
    selectedTractIds: Array<number>;
    loadingTracts: boolean;
    navigateToTractDetail?: (tractId: number) => void;
    updateSelectedTractIds: (tractId: number) => void;
}

const RunsheetTractListSlim = (props: IRunsheetTractListProps) => {
    const legDescEl = useRef([]);
    const popupEl = useRef([]);

    const cardClassName = 'dlc-card has-actions';

    // Isolating Card properties.
    const toggleLegalDesc = (state: boolean, index: number, clientX: number, clientY: number) => {
        if (state) {
            TweenLite.set(
                legDescEl.current[index],
                { top: `${clientY - 10}`, left: `${clientX + 10}`, height: 'auto', display: 'inline-block', background: 'white', border: '2px solid #6393C1', zIndex: 100 }
            );
        } else {
            TweenLite.to(legDescEl.current[index], 0.2, { height: '2.5rem', display: 'none', background: 'transparent', borderColor: 'transparent', zIndex: 0 });
        }
    };

    const togglePopup = (state: boolean, index: number) => {
        if (state) {
            TweenLite.to(popupEl.current[index], 0.2, { height: 'auto', width: 'auto', opacity: '1', pointerEvents: 'inherit' });
        } else {
            TweenLite.to(popupEl.current[index], 0.2, { height: '2rem', width: '1.7rem', opacity: '0', pointerEvents: 'none' });
        }
    };

    return (
        <CardContainer className="owner-tracts-results">
            {props.loadingTracts && (
                <>
                    <LoadingSpinner />
                    <span>Loading Tracts...</span>
                </>
            )}
            {props?.tracts && props?.tracts?.length > 0 &&
                props.tracts.map((x: LeaseGenerationTractDetail, index) => {
                    return (
                        <>
                            <span
                                ref={el => legDescEl.current[index] = el}
                                style={{
                                    borderRadius: '5px',
                                    display: 'none',
                                    overflow: 'hidden',
                                    position: 'absolute',
                                    border: '2px solid transparent',
                                    padding: '.3rem',
                                    background: 'transparent',
                                    borderColor: 'transparent',
                                    zIndex: 100,
                                    height: 'auto',
                                }}
                            >
                            {x?.legalDescription}
                            </span>
                            <div
                                key={index}
                                onClick={() => props.updateSelectedTractIds(x?.id)}
                                className={`${cardClassName} ${props.selectedTractIds.includes(x?.id) ? 'selected spaced' : 'spaced'}`}
                                style={{ display: 'block', height: '4.5rem' }}
                            >
                                <div style={{ margin: '.2rem' }}>
                                    <div style={{ display: 'flex' }}>
                                        {/*<div style={{ marginRight: '1rem' }}>Legal:</div>*/}
                                            <div 
                                                id={`legalDescriptionDiv${index}`} 
                                                style={{ width: '25%', textOverflow: 'ellipsis', overflow: 'hidden', display: 'inline-block', whiteSpace: 'nowrap' }}
                                            >
                                                {`${x?.sectionNumber}` + '.' + `${x?.tractNumber} - ${x?.tractName}`}
                                            </div>

                                            <span
                                                onMouseOver={(e) => toggleLegalDesc(true, index, e.clientX, e.clientY)}
                                                onMouseOut={() => toggleLegalDesc(false, index, 0, 0)}
                                                style={{ display: 'flex', whiteSpace: 'nowrap', width: '5%' }}
                                            >
                                                <div style={{fontSize: '20px', paddingRight: '20px'}}>👁‍🗨</div>
                                            </span>
                                            <div 
                                                id={`legalDescriptionDiv${index}`} 
                                                style={{ width: '65%', textOverflow: 'ellipsis', overflow: 'hidden', display: 'inline-block', whiteSpace: 'nowrap' }}
                                            >
                                                {x?.legalDescription}
                                            </div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        className="actions-panel"
                                    >
                                        <span className="options-button" onMouseOver={() => togglePopup(true, index)} />
                                    </div>
                                    <div className="actions-popup-mask" ref={el => popupEl.current[index] = el} onMouseLeave={() => togglePopup(false, index)}>
                                        <div className="actions-popup">
                                            <div className="actions-popup-header">Options</div>
                                            <div
                                                className="action"
                                                key={index}
                                                onClick={() => props.navigateToTractDetail(x.id)}
                                                style={{ width: '14rem', minHeight: '2.5rem' }}
                                            >
                                                Tract Detail
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    );
                })}
            {(props.tracts && props.tracts?.length === 0 && props.loadingTracts !== true) && <div>No Tracts for this Project</div>}
            {/* SurfaceOwnerships */}
        </CardContainer>
    );
};

export default RunsheetTractListSlim;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/RunsheetTractListSlim.tsx